let RandomTeamStacking = {
    RANDOM_TEAM_STACKING_MIN_PLAYERS_QUANTITY: 2,
    RANDOM_TEAM_STACKING_MAX_PLAYERS_QUANTITY: 4,

    RANDOM_TEAM_STACKING_PROJECTION_MULTIPLY_VALUE: 100,

    RANDOM_TEAM_STACKING_IS_USED: 'RANDOM_TEAM_STACKING_IS_USED',
    RANDOM_TEAM_STACKING_SET_PLAYERS_QUANTITY: 'RANDOM_TEAM_STACKING_SET_PLAYERS_QUANTITY',
    RANDOM_TEAM_STACKING_SET_TEAMS_ARE_CHOSEN_RANDOMLY: 'RANDOM_TEAM_STACKING_SET_TEAMS_ARE_CHOSEN_RANDOMLY',
    RANDOM_TEAM_STACKING_SET_CAPTAIN_IS_FORCED: 'RANDOM_TEAM_STACKING_SET_CAPTAIN_IS_FORCED',
    RANDOM_TEAM_STACKING_SET_TEAMS: 'RANDOM_TEAM_STACKING_SET_TEAMS',
    RANDOM_TEAM_STACKING_SET_STACK_TEAMS_IS_CHECKED: 'RANDOM_TEAM_STACKING_SET_STACK_TEAMS_IS_CHECKED',
    RANDOM_TEAM_STACKING_SET_STACK_TEAMS_EXPOSURE: 'RANDOM_TEAM_STACKING_SET_STACK_TEAMS_EXPOSURE',
    RANDOM_TEAM_STACKING_SET_TEAM_IS_CHECKED: 'RANDOM_TEAM_STACKING_SET_TEAM_IS_CHECKED',
    RANDOM_TEAM_STACKING_SET_TEAM_EXPOSURE: 'RANDOM_TEAM_STACKING_SET_TEAM_EXPOSURE',

    RANDOM_TEAM_STACKING_SET_DISALLOWED_POSITIONS_IS_USED: 'RANDOM_TEAM_STACKING_SET_DISALLOWED_POSITIONS_IS_USED',
    RANDOM_TEAM_STACKING_SET_DISALLOWED_POSITIONS: 'RANDOM_TEAM_STACKING_SET_DISALLOWED_POSITIONS',
};

export default RandomTeamStacking;
